module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-murale-wave.dc6ba97c.jpg";